import PropTypes from 'prop-types';
import { getInstance as getBootstrap } from 'utils/bootstrap';

import {
    BRAND_LIBRARY_DARK_TEXT_COLOR,
    BRAND_LIBRARY_LIGHT_TEXT_COLOR,
    BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
    BRAND_LIBRARY_HEADLINE_TEXT,
    BRAND_LIBRARY_BODY_TEXT,
    BRAND_LIBRARY_SUBHEADLINE_TEXT,
    BRAND_LIBRARY_BUTTON_HOVER_COLOR,
    BRAND_LIBRARY_BUTTON_TEXT,
} from 'common/constants/brandLibrary';
import {
    NODE_DESCENDANT_KEY_UNREGISTER_SESSION_BUTTON,
    NODE_DESCENDANT_KEY_UNREGISTER_WAITLIST_SESSION_BUTTON,
    NODE_DESCENDANT_KEY_ADD_TO_CALENDAR_BUTTON,
    NODE_DESCENDANT_KEY_REGISTER_SESSION_BUTTON,
    NODE_DESCENDANT_KEY_REGISTER_WAITLIST_SESSION_BUTTON,
    NODE_DESCENDANT_KEY_SESSION_LABEL,
} from 'common/compounds/AgendaTouchpoint/components/constants';

const flags = getBootstrap().get('flags', {});

export const descendantsDefaultProps = {
    card: {
        styles: {
            backgroundColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
            borderColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            borderWidth: {
                top: 1,
                bottom: 1,
                left: 1,
                right: 1,
            },
            borderRadius: 0,
        },
    },
    title: {
        styles: {
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontSize: 24,
            fontFamily: BRAND_LIBRARY_HEADLINE_TEXT,
        },
    },
    date: {
        styles: {
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontSize: 16,
            fontFamily: BRAND_LIBRARY_BODY_TEXT,
        },
    },
    speakerName: {
        styles: {
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontSize: 16,
            fontFamily: BRAND_LIBRARY_SUBHEADLINE_TEXT,
        },
    },
    speakerTitleCompany: {
        styles: {
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontSize: 16,
            fontFamily: BRAND_LIBRARY_BODY_TEXT,
        },
    },
    description: {
        styles: {
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontSize: 16,
            fontFamily: BRAND_LIBRARY_BODY_TEXT,
        },
    },
    tag: {
        styles: {
            fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
            fontSize: 16,
            fontFamily: BRAND_LIBRARY_BODY_TEXT,
            backgroundColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
            borderColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
            borderWidth: {
                top: 1,
                bottom: 1,
                left: 1,
                right: 1,
            },
            borderRadius: 20,
        },
    },
    ...(flags.isAgendaSessionRegistrationEnabled && {
        [NODE_DESCENDANT_KEY_SESSION_LABEL]: {
            styles: {
                fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontSize: 12,
                fontFamily: BRAND_LIBRARY_BODY_TEXT,
                backgroundColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                borderColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                borderWidth: {
                    top: 1,
                    bottom: 1,
                    left: 1,
                    right: 1,
                },
                borderRadius: 8,
            },
            meta: {
                noRegistrationRequiredContent: flags.isSessionVisibilityEnabled
                    ? 'Included in Agenda'
                    : 'No registration required',
                registrationClosedContent: 'Registration closed',
            },
        },
    }),
    ...(flags.isAgendaSessionRegistrationEnabled && {
        [NODE_DESCENDANT_KEY_REGISTER_SESSION_BUTTON]: {
            styles: {
                backgroundColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                backgroundColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
                fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontColorHover: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontSize: 16,
                fontFamily: BRAND_LIBRARY_BUTTON_TEXT,
                borderColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                borderColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
                borderWidth: {
                    top: 1,
                    bottom: 1,
                    left: 1,
                    right: 1,
                },
                borderRadius: 4,
            },
            meta: {
                content: flags.isSessionVisibilityEnabled ? 'Register' : 'Register for Session',
            },
        },
    }),
    ...(flags.isAgendaSessionRegistrationEnabled && {
        [NODE_DESCENDANT_KEY_UNREGISTER_SESSION_BUTTON]: {
            styles: {
                backgroundColor: null,
                backgroundColorHover: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                fontColorHover: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontSize: 16,
                fontFamily: BRAND_LIBRARY_BUTTON_TEXT,
                borderColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                borderColorHover: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                borderWidth: {
                    top: 1,
                    bottom: 1,
                    left: 1,
                    right: 1,
                },
                borderRadius: 4,
            },
            meta: {
                content: 'Remove Session',
            },
        },
    }),
    ...(flags.isAgendaSessionRegistrationEnabledPhase2 && {
        [NODE_DESCENDANT_KEY_REGISTER_WAITLIST_SESSION_BUTTON]: {
            styles: {
                backgroundColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                backgroundColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
                fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontColorHover: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontSize: 16,
                fontFamily: BRAND_LIBRARY_BUTTON_TEXT,
                borderColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                borderColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
                borderWidth: {
                    top: 1,
                    bottom: 1,
                    left: 1,
                    right: 1,
                },
                borderRadius: 4,
            },
            meta: {
                content: 'Join Waitlist',
            },
        },
    }),
    ...(flags.isAgendaSessionRegistrationEnabledPhase2 && {
        [NODE_DESCENDANT_KEY_UNREGISTER_WAITLIST_SESSION_BUTTON]: {
            styles: {
                backgroundColor: null,
                backgroundColorHover: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                fontColorHover: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontSize: 16,
                fontFamily: BRAND_LIBRARY_BUTTON_TEXT,
                borderColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                borderColorHover: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                borderWidth: {
                    top: 1,
                    bottom: 1,
                    left: 1,
                    right: 1,
                },
                borderRadius: 4,
            },
            meta: {
                content: 'Leave Waitlist',
            },
        },
    }),
    ...(flags.isAgendaSessionRegistrationEnabled && {
        [NODE_DESCENDANT_KEY_ADD_TO_CALENDAR_BUTTON]: {
            styles: {
                backgroundColor: null,
                backgroundColorHover: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                fontColorHover: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
                fontSize: 16,
                fontFamily: BRAND_LIBRARY_BUTTON_TEXT,
                borderColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
                borderColorHover: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
                borderWidth: {
                    top: 1,
                    bottom: 1,
                    left: 1,
                    right: 1,
                },
                borderRadius: 4,
            },
            meta: {
                content: 'Add to Calendar',
            },
        },
    }),
};

export const descendantsPropTypes = {
    card: PropTypes.shape({
        styles: PropTypes.shape({
            backgroundColor: PropTypes.number,
            borderColor: PropTypes.number,
            borderWidth: PropTypes.object,
            borderRadius: PropTypes.number,
        }),
    }),
    title: PropTypes.shape({
        styles: PropTypes.shape({
            fontColor: PropTypes.number,
            fontSize: PropTypes.number,
            fontFamily: PropTypes.number,
        }),
    }),
    date: PropTypes.shape({
        styles: PropTypes.shape({
            fontColor: PropTypes.number,
            fontSize: PropTypes.number,
            fontFamily: PropTypes.number,
        }),
    }),
    speakerName: PropTypes.shape({
        styles: PropTypes.shape({
            fontColor: PropTypes.number,
            fontSize: PropTypes.number,
            fontFamily: PropTypes.number,
        }),
    }),
    speakerTitleCompany: PropTypes.shape({
        styles: PropTypes.shape({
            fontColor: PropTypes.number,
            fontSize: PropTypes.number,
            fontFamily: PropTypes.number,
        }),
    }),
    description: PropTypes.shape({
        styles: PropTypes.shape({
            fontColor: PropTypes.number,
            fontSize: PropTypes.number,
            fontFamily: PropTypes.number,
        }),
    }),
    tag: PropTypes.shape({
        styles: PropTypes.shape({
            backgroundColor: PropTypes.number,
            borderColor: PropTypes.number,
            borderWidth: PropTypes.object,
            borderRadius: PropTypes.number,
        }),
    }),
};
